/**
 * F-vehicles-edsp — cores FIXAS dos chips de situação do veículo/dossier
 * (padrão eDSP: Reparado laranja, Faturado vermelho, Devis verde, Cadastro
 * azul; Recebido e bônus do Gestion). Fixas para não sumirem no tema claro.
 * Fonte única da lista /veiculos e da ficha do veículo.
 */
export const VEHICLE_STATUS_STYLE: Record<string, { bg: string; label: string }> = {
  // CEO 2026-10-26 — técnico assumiu, PDR ainda não finalizado (regra do quadro).
  em_reparacao: { bg: "#7C3AED", label: "vehicles.chipEmReparacao" },
  reparado: { bg: "#EA580C", label: "vehicles.chipReparado" },
  faturado: { bg: "#DC2626", label: "vehicles.chipFaturado" },
  devis: { bg: "#16A34A", label: "vehicles.chipDevis" },
  // Cliente pagou mas o técnico ainda não recebeu o repasse (âmbar = ação).
  recebido_pendente: { bg: "#D97706", label: "vehicles.chipRecebidoPendente" },
  // Ciclo fechado: cliente pagou E técnico pago.
  recebido_pago: { bg: "#65A30D", label: "vehicles.chipRecebidoPago" },
  cadastro: { bg: "#0284C7", label: "vehicles.chipCadastro" },
};
